// extracted by mini-css-extract-plugin
export default {"tutorialBG":"TutorialStyles_tutorialBG__FyE2p","show":"TutorialStyles_show__sd89n","tutorial":"TutorialStyles_tutorial__ctkf4","skipCount":"TutorialStyles_skipCount__D0qvy"};